import { useTranslation } from 'react-i18next'
import { ArrowUpDown } from 'lucide-react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useCamerasSort, isCamerasSort } from '@/hooks/useCamerasSort'
import { cn } from '@/lib/utils'

/** #277 — the Sort control of the Cameras page: latest event (default) or camera number.
 *  Reads and saves the signed-in user's choice through `useCamerasSort`. */
export function CameraSortSelect({ className }: { className?: string }) {
  const { t } = useTranslation('cameras')
  const [sort, setSort] = useCamerasSort()

  return (
    <Select value={sort} onValueChange={(value) => { if (isCamerasSort(value)) setSort(value) }}>
      <SelectTrigger
        aria-label={t('sort.label')}
        className={cn('h-9 w-auto gap-1.5 bg-background text-sm', className)}
      >
        <ArrowUpDown className="h-4 w-4 text-muted-foreground" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="latest_event">{t('sort.latestEvent')}</SelectItem>
        <SelectItem value="number">{t('sort.number')}</SelectItem>
      </SelectContent>
    </Select>
  )
}
